// src/components/DesktopHeader/DesktopHeader.jsx
import React from "react";
import logoMamute from "../../assets/logo_mamute.png";
function DesktopHeader({ titulo, subtitulo, onToggleSidebar }) {
  return (
    <header className="pc-header">
      <div className="pc-header-left">
        {onToggleSidebar && (
          <button
            type="button"
            className="pc-hamburger"
            aria-label="Alternar menu lateral"
            onClick={onToggleSidebar}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        )}

        <div className="pc-header-text">
          {/* Título único para manter altura consistente */}
          <h1 className="pc-header-title" title={titulo}>{titulo}</h1>
          {subtitulo && <p className="pc-header-sub">{subtitulo}</p>}
        </div>
      </div>

      <div className="pc-header-right">
<img 
          src={logoMamute} 
          alt="Logo Mamute" 
          className="pc-header-logo"
        />
      </div>
    </header>
  );
}

export default DesktopHeader;
